import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

const IMG = "https://images.unsplash.com/photo-1632854987458-d4950f98da3f?crop=entropy&cs=srgb&fm=jpg&q=85";

export const Reach = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="reach" ref={ref} className="relative py-24 md:py-32 overflow-hidden" data-testid="reach-section">
      <motion.div style={{ y }} className="absolute inset-0 z-0">
        <img src={IMG} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-[#0A0A0B]/80" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-6">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold" />
                <span className="flo-label">{t.reach.label}</span>
              </div>
              <h2 className="font-serif-display text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.98] mb-8">
                {t.reach.title}
              </h2>
              <p className="text-zinc-400 leading-relaxed max-w-md text-lg">{t.reach.body}</p>
            </Reveal>
          </div>

          <div className="md:col-span-6">
            <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
              {t.reach.countries.map((c, i) => (
                <Reveal
                  key={c}
                  delay={i * 0.04}
                  className="bg-[#0A0A0B] px-6 py-7 flex items-center justify-between hover:bg-[#18181B] transition-colors duration-300 group"
                  data-testid={`reach-country-${i}`}
                >
                  <span className="font-serif-display text-white text-lg md:text-xl">{c}</span>
                  <span className="text-xs text-zinc-600 group-hover:text-gold transition-colors">0{i + 1}</span>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
